export enum ProfileMenuItem {
  PERSONAL_INFORMATION = 'Personal Information',
  PAYMENT_METHOD = 'Payment Method',
  SUBSCRIPTION_HISTORY = 'Subscription History',
  MY_PLAN = 'My Plan'
}
